export default {
  overviewTitle: 'Verkoop',
  detailTitle: 'Verkoop',
  deleteTitle: 'deze Verkoop',
  url: '/sales',
  apiUrl: '/sales/',
  sortBy: ['date', 'invoice_nr'],
  sortDesc: [true, true],
  deletable: false,
  editable: true,
  filterName: 'sales',
  defaultPerPage: 100,
  quickFilter: {
    text: 'Zoek op factuurnr, klant',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Periode van', value: 'date_ge', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Periode tot', value: 'date_le', type: 'date', columns: 2, labelCols: 6, inputCols: 6},
    {text: 'Openstaand', value: 'unpaid', type: 'boolean', columns: 2, labelCols: 8, inputCols: 4},
    {text: 'Vervallen', value: 'overdue', type: 'boolean', columns: 2, labelCols: 8, inputCols: 4},
    {text: 'Niet verstuurd boekhouding', value: 'not_sent_accounting', type: 'boolean', columns: 2, labelCols: 8, inputCols: 4},
    {text: 'Niet verstuurd billit', value: 'not_sent_billit', type: 'boolean', columns: 2, labelCols: 8, inputCols: 4},
    {text: 'Na te kijken', value: 'mismatch_sum', type: 'boolean', columns: 2, labelCols: 8, inputCols: 4},
    {text: 'Firma', value: 'company_id', type: 'optionList', optionListName: 'companies', columns: 2, labelCols: 3, inputCols: 9},
    {text: 'Klant', value: 'customer_id', type: 'optionList', optionListName: 'customers', optionListParams: {is_active: true}, columns: 2, labelCols: 3, inputCols: 9}
  ],
  newRecord: {
  },
  isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Factuur', value: 'id', link: '/sales/{id}', width: '5%'},
    {text: 'Factuurdatum', value: 'date', width: '8%', filter: 'date'},
    {text: 'Factuurnummer', value: 'invoice_nr', width: '8%'},
    {text: 'Klant', value: 'customer_name', width: '13%'},
    {text: 'Omschrijving', value: 'description', width: '5%', filter: 'saledescription'},
    {text: 'Bedrag', value: 'amount', width: '8%', align: 'right', filter: 'euro'},
    {text: 'BTW', value: 'vat', width: '8%', align: 'right', filter: 'euro'},
    {text: 'Totaal', value: 'total_amount', width: '8%', align: 'right', filter: 'euro'},
    // {text: 'Nr Uittreksel', value: 'account_nr', width: '10%'},
    // {text: 'Project', value: 'is_project', type: 'boolean', width: '10%'},
    // {text: 'Betaald', value: 'is_payed', type: 'boolean', width: '10%'},
    // {text: 'Is_Selected', value: 'is_selected', type: 'boolean', width: '10%'},
    // {text: 'Is_Show_Payment', value: 'is_show_payment', type: 'boolean', width: '10%'},
    {text: 'Datum Email Klant', value: 'sent_email', width: '7%', filter: 'date'},
    {text: 'Boekhouding Verstuurd', value: 'sent_accounting', width: '7%', filter: 'date'},
    {text: 'Billit Verstuurd', value: 'sent_billit', width: '7%', filter: 'date'},
    {text: 'Herinnering Verstuurd', value: 'sent_reminder', width: '7%', filter: 'date'},
    {text: 'Datum Uittreksel', value: 'bank_date', width: '7%', filter: 'date'},
    {text: 'Bestand', value: 'file', type: 'file', width: '7%', align: 'center', sortable: false, access: 'manager'}
  ],
  totalFields: ['Bedrag', 'BTW']
};
